import { Unit } from "@/types";

export const getUnit = (value: unknown): Unit | null => {
  if (typeof value === "string") {
    const valueNormalized = value.trim().toUpperCase();

    return valueNormalized === "CELSIUS" || valueNormalized === "FAHRENHEIT"
      ? valueNormalized
      : null;
  }

  return null;
};
